module.exports = __webpack_public_path__ + "static/media/tasha.551ccd11.jpg";